// src/components/Pages/SnapChase/useCameraVideo.ts
import { useEffect, useRef, useState } from "react";
var DEFAULT_VIDEO_CONSTRAINTS = {
  facingMode: { ideal: "environment" },
  width: { ideal: 640 },
  height: { ideal: 360 }
};
function useCameraVideo(enabled = true, constraints = DEFAULT_VIDEO_CONSTRAINTS) {
  const videoRef = useRef(null);
  const [videoReady, setVideoReady] = useState(false);
  const [cameraError, setCameraError] = useState(false);
  useEffect(() => {
    if (!enabled) return;
    const v = videoRef.current;
    if (!v) return;
    setVideoReady(false);
    setCameraError(false);
    let stream = null;
    let mounted = true;
    const start = async () => {
      try {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          throw new Error("Camera API not available");
        }
        stream = await navigator.mediaDevices.getUserMedia({
          video: constraints,
          audio: false
        });
        if (!mounted) {
          stream.getTracks().forEach((t) => t.stop());
          return;
        }
        v.srcObject = stream;
        await v.play();
        if (!mounted) return;
        setVideoReady(true);
      } catch (e) {
        console.warn("Camera access denied, using fallback 360 image:", e);
        if (stream) {
          stream.getTracks().forEach((t) => t.stop());
          stream = null;
        }
        if (!mounted) return;
        v.srcObject = null;
        setVideoReady(false);
        setCameraError(true);
      }
    };
    start();
    return () => {
      mounted = false;
      if (stream) {
        stream.getTracks().forEach((t) => t.stop());
        if (v) v.srcObject = null;
      }
    };
  }, [enabled, constraints]);
  return { videoRef, videoReady, cameraError };
}

export {
  useCameraVideo
};
//# sourceMappingURL=chunk-QEROQ2RW.mjs.map